import { Box } from '@mui/system'
import React, { useState } from 'react'
import Icons from '../Icons/icons'
import "./DropdownMessage.scss"
const DropdownMessage = ({ content, index }) => {
  const [openDropdown, setOpenDropdown] = useState(false)
  return (
    <Box className="dropdown-message-container">
      <Box className="message-box" onClick={() => setOpenDropdown(!openDropdown)}>
        <Box className="message-number"><Box>{index}</Box></Box>
        <Box className="message-title-arrow">
          <Box> {content.title}</Box>
          <Box className="up-down-arrow"> {openDropdown ? <Icons.upwardArrow /> : <Icons.downwardArrow />} </Box>
        </Box>
      </Box>
      <Box className="link-text-main">
        {openDropdown && <Box className="link-text-container">
          {content.text_url &&
            content.text_url.map((data, index) => (
              <Box key={index}>
                <a href={data.url} target="_blank" rel="noreferrer">
                  <label>{data.text} </label> <Icons.link_redirect_arrow />
                </a>
              </Box>
            ))}

          {content?.permission &&
            <Box className="dropdown-permissions-container">
              {content?.permission.icon}
              <h2 className="dropdown-message-title">{content?.permission.title}</h2>
              <p className="dropdown-message-point">{content?.permission.message}</p>
            </Box>
          }
          {content?.videoUrl &&
            <Box className="dropdown-permissions-container">
              <p className="dropdown-message-point">{content?.videoUrl.text}</p>
              <video
                className="video-container"
                controls
                controlsList="nodownload"
              >
                <source
                  src={content?.videoUrl.url}
                  type="video/mp4"
                />
              </video>
            </Box>
          }

        </Box>}
      </Box>
    </Box>
  )
}

export default DropdownMessage